__turbopack_context__.v({
  "heartIcon": "BecomeFanButton-module-scss-module__MfxqFW__heartIcon",
  "trigger": "BecomeFanButton-module-scss-module__MfxqFW__trigger",
});
